import { Delegate } from "dom-delegate";
import smoothScroll from "smoothscroll";

let instances = [];

class ScrollToAnchor {
    /**
     * Creates a new scroll to anchor element.
     *
     * @param {HTMLElement} element
     */
    constructor(element) {
        this.listener = new Delegate(element);
        if (element.tagName === "SELECT") {
            this.bindChangeEvents(element);
        } else {
            this.anchorToId = element.getAttribute("href");
            this.bindClickEvents();
        }

        this.anchorToElement = document.querySelector(this.anchorToId);
    }

    /**
     * Binds the click event listener from the element.
     *
     * @return {void}
     */
    bindClickEvents() {
        this.listener.on("click", (e) => {
            e.preventDefault();
            // Remove focus from the clicked element
            e.target.blur();
            // Add history for this navigation so the back button works
            window.history.pushState({}, "", this.anchorToId);
            // Scroll to the anchor
            smoothScroll(this.anchorToElement, 1000);
        });
    }

    /**
     * Binds the change event listener from the element.
     *
     * @param {HTMLElement} element
     * @return {void}
     */
    bindChangeEvents(element) {
        this.listener.on("change", (e) => {
            e.preventDefault();
            this.anchorToId = element.value;
            this.anchorToElement = document.querySelector(this.anchorToId);
            smoothScroll(this.anchorToElement, 1000);
        });
    }

    /**
     * Unbinds the event listeners from the elements.
     *
     * @return {void}
     */
    unbindEvents() {
        this.listener.destroy();
    }
}

export default {
    init: (element) => {
        instances.push(new ScrollToAnchor(element));
    },

    destroy: () => {
        instances.forEach((instance) => instance.destroy());
        instances = [];
    },
};
